import React from 'react'
import { Navbar, Button } from 'react-bootstrap'

//const basedir = `${process.env.PUBLIC_URL}`;


export default function Navigation(props){

    const modeldescr = props.model?props.model.modelname:null;

    const bg={
        bakground: 'transparent'
        /*backgroundImage: `url(${basedir}/img/leggera-bg-navbar.jpg)`*/
    } ;
    return(
        <Navbar  sticky="top" expand="lg" className='col-12' style={bg}>
            <Navbar.Brand href="https://www.leggeraliftvilla.com" className='col-3'>
                <div className='leggera-logo col-1'>
                    <span className='App-title md-2 p-2 text-light'>Lift Configurator</span>
                </div>
            </Navbar.Brand>
            {props.isValid?
            <>
                <div className='col-3 text-white'><label>Selected model:</label> <span className='text-enhanced'>{modeldescr}</span></div>
                <div className='col-5'></div>
                <div className='col-1 align-right'>
                <Button onClick={props.reset}>RESET</Button>
                </div>
            </>
            :null}
        </Navbar>
    )
}
